module.exports = "../study/imgs/maps/Nagano/S8/WaterEnvironment/Chlave/Nagano_Chlave_GFDL_RCP85_Mid.png";